import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent } from 'core/components';
import { withLocale } from 'core/decorators';
import { Row, Col, Button, BlockTitle, Icon } from 'core/components/Framework7';
import { deleteAddress } from 'core/module/operations';
import { AddressItem } from 'content/components';

import classes from './styles.module.css';

class AddressList extends PureComponent {
  constructor(props) {
    super(props)

    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {}
  }

  renderAddressItems() {
    const { items } = this.props;

    return items.map(item => {
      return this.renderAddressItem(item)
    })
  }

  renderAddressItem(item) {
    return (
      <AddressItem item={item} key={item.id} />
    )
  }

  render() {
    return (
      <div className={classes.container}>
        <Button large raised
          href="/address/new"
          icon="mdi-plus"
          text={'اضافه کردن آدرس'}
          className={`${classes.addAddress} button-top-full-width`}
        />
        <div className={classes.productRow}>
          {this.renderAddressItems()}
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({

  }),
  {
    deleteAddress
  }
)(withLocale('home')(autobind(AddressList)))
